import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMedal({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14 11.8a5.5 5.5 0 115.36-5.5c.04 3-2.36 5.46-5.36 5.5zm1.24.87l1.92 3.2 1.18-2.2H15l-1.95-3.22a6.41 6.41 0 01-3.67 2.22zm-6.4-2.26a6.5 6.5 0 003.65 2.24l-1.97 3.22-1.14-2.2H1l1.97-3.26zm5-2.24l1.84 1-.32-2.12L11 5.57l-2.06-.35-.92-1.92-.95 1.9L5 5.5l1.47 1.52-.36 2.11 1.86-.96z"
      />
    </svg>
  );
}

SvgBasicMedal.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMedal.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMedal svgRef={ref} {...props} />);
export default ForwardRef;
